import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutContainerComponent } from './layout-container.component';
import { VerticalModule } from './vertical/vertical.module';
import { SharedModule } from './shared/shared.module';
import {NgxSpinnerModule} from "ngx-spinner";

@NgModule({
  declarations: [
    LayoutContainerComponent
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    SharedModule,
    VerticalModule,
    NgxSpinnerModule
  ],
  exports: [LayoutContainerComponent],

})
export class LayoutModule { }
